export function validateFileUpload({ file, fieldName, maxFileSize, allowedFileType }) {
    if (file === null) {
        return {
            isError: false,
            message: "",
            name: fieldName,
        };
    }

    if (file.size > maxFileSize) {
        return {
            isError: true,
            message: "File size is too large",
            name: fieldName,
        };
    }

    if (!allowedFileType.includes(file.type)) {
        return {
            isError: true,
            message: "Invalid file type",
            name: fieldName,
        };
    }

    return {
        isError: false,
        message: "",
        name: fieldName,
    };
}